import NavigationMenu from 'components/commercetools-ui/organisms/NavigationMenu';
import { useAccount } from 'frontastic/hooks';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop, semiLargeDesktop } from 'helpers/utils/screensizes';

const ProjectLayout = ({ children }: any) => {
  const { loggedIn } = useAccount();
  const [isDesktopSize] = useMediaQuery(desktop);
  const [issemiLargeDesktop] = useMediaQuery(semiLargeDesktop);

  return (
    <div
      id="project-builder"
      className={`sidemenu-container flex flex-row p-[60px] ${issemiLargeDesktop ? 'gap-[128px]' : 'gap-[50px]'}`}
    >
      {isDesktopSize && <NavigationMenu loggedIn={loggedIn} />}
      <div>{children}</div>
    </div>
  );
};
export default ProjectLayout;
